import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Hours
export const submitHours = (data) => api.post('/hours', data);
export const getHours = (params) => api.get('/hours', { params });
export const reviewHours = (logId, data) => api.put(`/hours/${logId}/review`, data);
export const bulkReviewHours = (data) => api.post('/hours/bulk-review', data);

// Users
export const getUsers = (params) => api.get('/users', { params });
export const updateUser = (userId, data) => api.put(`/users/${userId}`, data);
export const deleteUser = (userId) => api.delete(`/users/${userId}`);
export const assignUserCommittees = (userId, committees) => api.post(`/users/${userId}/committees`, { committees });

// Service Types
export const getServiceTypes = () => api.get('/service-types');

// Committees
export const getCommittees = () => api.get('/committees');
export const createCommittee = (data) => api.post('/committees', data);
export const updateCommittee = (id, data) => api.put(`/committees/${id}`, data);
export const deleteCommittee = (id) => api.delete(`/committees/${id}`);
export const getCommitteeMembers = (id) => api.get(`/committees/${id}/members`);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getDashboardChartData = () => api.get('/dashboard/chart-data');

// Reports
export const getReportSummary = (params) => api.get('/reports/summary', { params });
export const downloadPdfReport = (params) => {
  const query = new URLSearchParams(params).toString();
  window.open(`${API}/reports/pdf?${query}`, '_blank');
};
export const downloadCsvReport = (params) => {
  const query = new URLSearchParams(params).toString();
  window.open(`${API}/reports/csv?${query}`, '_blank');
};
export const sendMonthlySummary = () => api.post('/reports/send-monthly-summary');

// Audit Logs
export const getAuditLogs = (params) => api.get('/audit-logs', { params });

// Profile
export const getProfile = () => api.get('/profile');
export const updateProfile = (data) => api.put('/profile', data);
export const getUserProfile = (userId) => api.get(`/profile/${userId}`);

// Admin Password Reset
export const adminResetPassword = (userId, newPassword) => api.post(`/admin/reset-password/${userId}`, { new_password: newPassword });

// Committee Supervisors
export const updateCommitteeSupervisors = (committeeId, supervisorIds) => api.put(`/committees/${committeeId}/supervisors`, { supervisor_ids: supervisorIds });
export const getCommitteeSupervisors = (committeeId) => api.get(`/committees/${committeeId}/supervisors`);

// Walk-in Registration
export const adminRegisterWalkin = (data) => api.post('/admin/register-walkin', data);

// Check-in/Check-out
export const checkin = (data) => api.post('/checkin', data);
export const checkout = () => api.post('/checkout');
export const getCheckinStatus = () => api.get('/checkin/status');
